import { Component, Input } from '@angular/core';
import { CaseProgress } from 'app/domain';
import { StageStep, StageStepStatus } from '../stage-stepper/stage-stepper.component';

@Component({
  selector: 'case-progress-bar',
  templateUrl: './case-progress-bar.component.html'
})
export class CaseProgressBarComponent {
  @Input() progress: CaseProgress;

  get steps(): StageStep[] {
    if (!this.progress) return [];
    return this.progress.steps.map(s => {
      let status = StageStepStatus.Pending;
      if (this.progress.stepCompleted(s)) status = StageStepStatus.Completed;
      else if (this.progress.stepPastDue(s)) status = StageStepStatus.PastDue;
      else if (this.progress.stepActive(s)) status = StageStepStatus.Active;
      return { label: s, status };
    });
  }
}
